export default {
  path: 'messages',
  name: 'messages',
  meta: { requiresAuth: true, legacy: true },
  redirect: { name: 'community.all-messages' },
  children: [{ path: ':_(.*)', redirect: { name: 'community.all-messages' } }],
};
